import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getInvoiceById } from "../../core/axios/endpoints";
import PageLoader from "../../components/page-loader";
import { PDFDownloadLink } from '@react-pdf/renderer';
import InvoiceDocument from "../../components/invoice-pdf";
import { NETWORK_ERROR } from "../../utils/constants";

const ClientBetalingDetailsPage = (props) => {
    const [BetalingDetails, setBetalingDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const [isError, setError] = useState(false);
    const { facturenId } = useParams();
    const [isNetworkError, setIsNetworkError] = useState(false);
    const navigate = useNavigate();
    const getBetalingDetails = async () => {
        setLoading(true);
        try {
            const data = await getInvoiceById(facturenId);
            setBetalingDetails(data);
        } catch (err) {
            
            if(err?.isNetworkError){
                setIsNetworkError(true);
            }
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getBetalingDetails();
    }, []);

    const formatNumber = (number) => {
        return number.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };
    if (loading) {
        return <PageLoader />;
    }

    if (isError) {
        return (
            <div className="main-wrapper">
                <div className="error-box">
                    <h1>{isNetworkError ? "503" : "404" }</h1>
                    <h3 className="h2 mb-3">
                        <i className="fas fa-exclamation-circle" /> Oops! {isNetworkError ? "Network Error!" : ""}
                    </h3>
                    <p className="h4 font-weight-normal mt-2">
                        {isNetworkError ? NETWORK_ERROR : "Er is iets misgegaan. Probeer het later opnieuw"}
                    </p>
                    <button onClick={() => navigate(-1)} className="customized-btn mt-6">
                       Go Back
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="page-wrapper">
            <div className="content">
                <header className="mb-6">
                    <nav className="mb-1 text-xs text-ink-subtlest">
                        <button type="button" onClick={() => navigate(-1)} className="hover:underline">Facturen</button>
                        <span className="mx-1">/</span>
                        <span>Betaling</span>
                    </nav>
                    <h1 className="text-2xl font-medium text-ink">
                        Factuur{BetalingDetails?.InvoiceId ? ` ${BetalingDetails.InvoiceId}` : ""}
                    </h1>
                </header>

                <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
                    <div className="rounded bg-white p-4 shadow-card">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Regeling</p>
                        <p className="mt-1 text-2xl font-medium tabular-nums text-ink">{BetalingDetails?.application?.regling || "N/A"}</p>
                    </div>
                    <div className="rounded bg-white p-4 shadow-card">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Datum betaling</p>
                        <p className="mt-1 text-2xl font-medium tabular-nums text-ink">{ BetalingDetails?.betaaldDateTime ? new Date(BetalingDetails?.betaaldDateTime).toLocaleDateString() : "N/A"}</p>
                    </div>
                    <div className="rounded bg-white p-4 shadow-card">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtlest">Bedrag</p>
                        <p className="mt-1 text-2xl font-medium tabular-nums text-ink">€{BetalingDetails?.application?.totaal || "0,00"}</p>
                    </div>
                </div>

                <div className="max-w-md rounded bg-white p-5 shadow-card">
                    <h2 className="text-base font-semibold text-ink">Factuurinformatie</h2>
                    <dl className="mt-3 space-y-2 text-sm">
                        <div className="flex items-baseline justify-between gap-6">
                            <dt className="text-ink-subtlest">Subtotaal:</dt>
                            <dd className="tabular-nums text-ink">€{formatNumber(BetalingDetails?.application?.exclusiveBTW || '0')}</dd>
                        </div>
                        <div className="flex items-baseline justify-between gap-6">
                            <dt className="text-ink-subtlest">BTW:</dt>
                            <dd className="tabular-nums text-ink">€{formatNumber(BetalingDetails?.application?.inclusiveBTW || '0')}</dd>
                        </div>
                        <div className="flex items-baseline justify-between gap-6 border-t border-line pt-2">
                            <dt className="font-semibold text-ink">Totaal</dt>
                            <dd className="font-semibold tabular-nums text-ink">€{formatNumber(BetalingDetails?.application?.totaal || '0')}</dd>
                        </div>
                    </dl>
                </div>

                <div className="mt-6 flex flex-wrap items-center justify-between gap-2">
                    <div onClick={() => navigate(-1)}>
                        <button className="inline-flex h-8 items-center justify-center rounded bg-[#091E420F] px-3 text-sm font-medium text-ink hover:bg-[#091E4224]">Terug</button>
                    </div>
                    <div>

                   <PDFDownloadLink
                document={<InvoiceDocument invoiceData={BetalingDetails} />}
                fileName={BetalingDetails?.InvoiceId + ".pdf"}
                className="inline-flex h-8 items-center justify-center rounded bg-brand px-3 text-sm font-medium text-white hover:bg-brand-hover hover:text-white"
              >
                 {({ blob, url, loading, error }) =>
                  loading ? 'Loading document...' : 'Download PDF'
               }
                  </PDFDownloadLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientBetalingDetailsPage;
